import type { ProductPackagingUnitProps } from '@maestro/commerce-blocks/components/product-packaging-unit/product-packaging-unit.types'

import classNames from 'classnames'

import { theme } from '@maestro/local/theme'

import '@maestro/commerce-blocks/components/product-packaging-unit/styles/product-packaging-unit.scss'

export default function ProductPackagingUnit(props: ProductPackagingUnitProps) {
  const { className, packagingUnit } = props
  const { isEnabledPackagingUnit } = theme().product.details

  if (!isEnabledPackagingUnit || !packagingUnit) {
    return null
  }

  return (
    <span className={classNames('product-packaging-unit', className)}>
      {packagingUnit}
    </span>
  )
}
